import { Container } from 'inversify';
import { Api } from '#src/react/api/Api';
import { DI_CONTAINER_TYPE } from '#srcJs/di-container';

const initApi = (diContainer: Container): void => {
  diContainer.bind<Api>(DI_CONTAINER_TYPE.api)
    .toDynamicValue(() => new Api(diContainer))
    .inSingletonScope();
};

export { initApi };
